import { chartDataFromTransferPayload } from "./chart-data.js";

export class DataWorkerClient {
  constructor() {
    this.worker = new Worker(new URL("../workers/data-worker.js", import.meta.url), {
      type: "module",
      name: "flexcharting-data-worker"
    });
    this.nextRequestId = 1;
    this.pending = new Map();
    this.worker.addEventListener("message", (event) => this.onMessage(event));
    this.worker.addEventListener("error", () => {
      this.rejectAll(new Error("The chart data worker failed."));
    });
  }

  process(bars, signal) {
    const requestId = this.nextRequestId;
    this.nextRequestId += 1;
    return new Promise((resolve, reject) => {
      const abort = () => {
        this.pending.delete(requestId);
        reject(new DOMException("The data transformation was canceled.", "AbortError"));
      };
      if (signal?.aborted) {
        abort();
        return;
      }
      signal?.addEventListener("abort", abort, { once: true });
      this.pending.set(requestId, { resolve, reject, signal, abort });
      this.worker.postMessage({ type: "transform", requestId, bars });
    });
  }

  onMessage(event) {
    const message = event.data;
    const pending = this.pending.get(message?.requestId);
    if (!pending) return;
    this.pending.delete(message.requestId);
    pending.signal?.removeEventListener("abort", pending.abort);
    if (message.type === "transformed") {
      pending.resolve({
        data: chartDataFromTransferPayload(message.payload),
        duration: message.duration
      });
      return;
    }
    pending.reject(new Error(message.message || "The chart data worker rejected the response."));
  }

  rejectAll(error) {
    for (const pending of this.pending.values()) {
      pending.signal?.removeEventListener("abort", pending.abort);
      pending.reject(error);
    }
    this.pending.clear();
  }

  dispose() {
    this.rejectAll(new Error("The chart data worker was disposed."));
    this.worker.terminate();
  }
}
